import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { toArray, map, debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { range, merge, of, OperatorFunction } from 'rxjs';


import { SisrhService } from '@app/services/sisrh.service';
import { ModalService } from '@app/shared/services/modal.service';
import { AppUtil } from '@app/utils/app.util';
import { AutenticacaoService } from '@app/services/autenticacao.service';
import { Observable } from 'rxjs';

import layout from '@assets/json/layout.json';
import areaFormacao from '@assets/json/area-formacao.json';
import escolaridade from '@assets/json/escolaridade.json';
import statusCurso from '@assets/json/status-curso.json';
import { AreaFormacao, Curriculo, Curso, ExperienciaProfissional, Formacao } from '@app/models/sisrh.model';

@Component({
  templateUrl: './curriculo.page.html'
})
export class CurriculoPage implements OnInit {

  fgFormacao: FormGroup;
  fgExperienciaProfissional: FormGroup;
  fgCurso: FormGroup;
  enviando = false;
  enviandoF = false;
  enviandoEp = false;
  enviandoC = false;
  idInscricao: string;
  guidEmpty = '00000000-0000-0000-0000-000000000000';

  listaFormacoes: Formacao[] = [];
  listaExperienciasProfissionais: ExperienciaProfissional[] = [];
  listaCursos: Curso[] = [];

  anoAtual = new Date().getFullYear();
  listaEscolaridade = escolaridade;
  listaAno: Observable<any[]> = merge(of(''), range(this.anoAtual - 100, this.anoAtual - (this.anoAtual - 110)))
    .pipe(map(x => ({ idAno: x, ano: x ? x : 'Selecione' })), toArray());
  listaAreaFormacao = areaFormacao;
  listaStatusCurso = statusCurso;

  cpfCandidato;
  layout = layout.curriculoPage;

  constructor(
    private autenticacaoService: AutenticacaoService,
    private fb: FormBuilder,
    private modalService: ModalService,
    private router: Router,
    private sisrhService: SisrhService
  ) { }

  ngOnInit() {


    this.cpfCandidato = this.autenticacaoService.getValorUsuarioAtualCandidato.cpf;

    this.autenticacaoService.verificarTermoUsuario(this.autenticacaoService.getValorUsuarioAtualCandidato.cpf, 'PORTAL_CANDIDATO', 'TERMO_DADOS_PESSOAIS')
    .subscribe(
      result => {
        if (!result) {
          this.router.navigate(['/termoUsuario']);
        }
      }
    );



    this.idInscricao = localStorage.getItem('idInscricao');

    this.formacoes();
    this.experienciasProfissionais();
    this.cursos();

    this.reset('f');
    this.reset('ep');
    this.reset('c');

  }

  get cf() {

    return this.fgFormacao.controls;

  }

  get cep() {

    return this.fgExperienciaProfissional.controls;

  }

  get cc() {

    return this.fgCurso.controls;

  }

  salvar() {

    if (this.listaFormacoes.length === 0) {
      this.modalService.alert('e', 'Erro', 'O formulário Formação é obrigatório.');
      return;
    }

    const curriculo: Curriculo = {
      idCandidato: this.autenticacaoService.getValorUsuarioAtualCandidato.idCandidato,
      formacoes: this.listaFormacoes,
      experienciasProfissionais: this.listaExperienciasProfissionais,
      cursos: this.listaCursos
    };

    this.desativarCurriculo();

    this.sisrhService
      .salvarCurriculo(curriculo)
      .subscribe(x => {
        if (x.success) {
          this.router.navigate([
            localStorage.getItem('idInscricao') ? '/candidato/inscricao' : '/vagas/lista'
          ]);
        }
      }, () => {
        this.modalService
          .alert('e', 'Erro', 'Ocorreu um erro. Tente novamente mais tarde.')
          .subscribe(() => this.ativarCurriculo());
      });


  }

  ativarCurriculo() {
    this.enviando = false;
    this.fgFormacao.enable();
    this.fgExperienciaProfissional.enable();
    this.fgCurso.enable();
  }

  desativarCurriculo() {
    this.enviando = true;
    this.fgFormacao.disable();
    this.fgExperienciaProfissional.disable();
    this.fgCurso.disable();
  }



  ok(opcao: string = 't') {

    switch (opcao) {
      case 'f':
        this.enviandoF = false;
        AppUtil.focalizarCampo('idEscolaridade');
        break;
      case 'ep':
        this.enviandoEp = false;
        AppUtil.focalizarCampo('idEmpresa');
        break;
      case 'c':
        this.enviandoC = false;
        AppUtil.focalizarCampo('idNomeCurso');
        break;
      case 't':

        break;
    }

  }

  formacoes() {

    this.sisrhService
      .curriculo('formacao', this.autenticacaoService.getValorUsuarioAtualCandidato.idCandidato)
      .subscribe(x => this.listaFormacoes = x);

  }

  experienciasProfissionais() {

    this.sisrhService
      .curriculo('experiencia-profissional', this.autenticacaoService.getValorUsuarioAtualCandidato.idCandidato)
      .subscribe(x => this.listaExperienciasProfissionais = x);

  }

  cursos() {

    this.sisrhService
      .curriculo('curso', this.autenticacaoService.getValorUsuarioAtualCandidato.idCandidato)
      .subscribe(x => this.listaCursos = x);

  }

  incluir(opcao: string) {
    switch (opcao) {
      case 'f':
        this.enviandoF = true;
        if (this.fgFormacao.invalid) {
          return;
        }
        this.listaFormacoes.push(this.fgFormacao.value);
        this.ok('f');
        this.reset('f');
        break;
      case 'ep':
        this.enviandoEp = true;
        if (this.fgExperienciaProfissional.invalid) {
          return;
        }
        this.listaExperienciasProfissionais.push(this.fgExperienciaProfissional.value);
        this.ok('ep');
        this.reset('ep');
        break;
      case 'c':
        this.enviandoC = true;
        if (this.fgCurso.invalid) {
          return;
        }
        this.listaCursos.push(this.fgCurso.value);
        this.ok('c');
        this.reset('c');
        break;
    }
  }

  remover(opcao: string, id: string, index: number) {

    if (id === this.guidEmpty) {
      switch (opcao) {
        case 'f':
          this.listaFormacoes.splice(index, 1);
          break;
        case 'ep':
          this.listaExperienciasProfissionais.splice(index, 1);
          break;
        case 'c':
          this.listaCursos.splice(index, 1);
          break;
      }
    } else {
      this.sisrhService
        .excluirCurriculo({ idCandidato: this.autenticacaoService.getValorUsuarioAtualCandidato.idCandidato, id, opcao })
        .subscribe(x => {
          if (x.success) {
            switch (opcao) {
              case 'f':
                this.formacoes();
                break;
              case 'ep':
                this.experienciasProfissionais();
                break;
              case 'c':
                this.cursos();
                break;
            }
          }
        });
    }

  }

  reset(opcao: string) {
    switch (opcao) {
      case 'f':
        this.fgFormacao = this.fb.group({
          idFormacao: this.guidEmpty,
          escolaridade: ['', [Validators.required]],
          areaFormacao: ['', [Validators.required]],
          nomeFormacao: ['', [Validators.required]],
          anoConclusao: ['', [Validators.required]]
        });
        this.fgFormacao.get('areaFormacao').disable();
        break;
      case 'ep':
        this.fgExperienciaProfissional = this.fb.group({
          idExperienciaProfissional: this.guidEmpty,
          empresa: ['', [Validators.required]],
          cargo: ['', [Validators.required]],
          dataContratacao: ['', [Validators.required]],
          dataSaida: ['', [Validators.required]],
          cargoAtual: false,
          atividadesDesenvolvidas: ['', [Validators.required]]
        });
        break;
      case 'c':
        this.fgCurso = this.fb.group({
          idCurso: this.guidEmpty,
          nomeCurso: ['', [Validators.required]],
          nomeInstituicaoExecutora: ['', [Validators.required]],
          status: ['', [Validators.required]],
          ano: ['', [Validators.required]],
          cargaHoraria: ['', [Validators.required]]
        });
        break;
    }
  }

  desativaDataSaida(evento) {

    if (evento.target.checked) {
      this.cep.dataSaida.setValue('');
      this.cep.dataSaida.disable();
    } else {
      this.cep.dataSaida.enable();
    }

  }

  desativarFormacao(idEscolaridade: string) {

    if (
      idEscolaridade === '0c66a950-1afb-4b33-8a5e-7806a1576256'
      || idEscolaridade === '83fd8eb9-b5c8-435e-8301-d715bb5b123a'
      || idEscolaridade === '9d4de925-b526-4d3b-8531-2e3a8a1aa54c'
      || idEscolaridade === '57ca019e-80ed-42a5-b953-a17de682b6a2'
    ) {
      this.fgFormacao.controls.areaFormacao.disable();
      this.fgFormacao.controls.areaFormacao.setValue('');
      this.fgFormacao.controls.nomeFormacao.disable();
      this.fgFormacao.controls.nomeFormacao.setValue('');
    } else {
      this.fgFormacao.controls.areaFormacao.enable();
      this.fgFormacao.controls.nomeFormacao.enable();
    }


  }

  desativarCurso(idStatus: string) {

    if (
      idStatus === '90e17614-7d67-48a2-927c-e15a1ae562e8'
    ) {
      this.fgCurso.controls.ano.disable();
      this.fgCurso.controls.ano.setValue('');
      this.fgCurso.controls.cargaHoraria.disable();
      this.fgCurso.controls.cargaHoraria.setValue('');
    } else {
      this.fgCurso.controls.ano.enable();
      this.fgCurso.controls.cargaHoraria.enable();
    }


  }

  formatarAreaFormacao = (area: AreaFormacao) => area.areaFormacao;

  buscarAreasFormacao: OperatorFunction<string, readonly AreaFormacao[]> = (text$: Observable<string>) => text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => this.listaAreaFormacao.filter(area => new RegExp(term, 'mi').test(area.areaFormacao)).slice(0, 10))
  )
}
